<form class="custom-forms form-horizontal" action="#" method="POST" novalidate="novalidate" id="form_body"
   [formGroup]="ProductLocation">
   <div class="row generalSearchSection">
	 <div class="col-lg-12 d-flex ">
	   <div class="col-lg-3">
		 <ng-multiselect-dropdown (keydown.enter)="$event.preventDefault()" name="Product"
		   [placeholder]="'Select Product'" [data]="products" formControlName="product_id"
		   [settings]="dropdownProductSettings" (onSelect)="onItemSelectProduct($event)"
		   (onSelectAll)="onSelectAllProduct($event)" (onDeSelect)="onItemDeSelectProduct($event)"
		   (onDeSelectAll)="onItemDeSelectAllProduct($event)">
		 </ng-multiselect-dropdown>
	   </div>
	   <!-- <div class="col-lg-3"> -->
		 <!-- <ng-multiselect-dropdown (keydown.enter)="$event.preventDefault()" name="regions"
		   [placeholder]="'Select region'" [data]="region" formControlName="region_id"
		   [settings]="dropdownregionSettings" (onSelect)="onItemSelectregion($event)"
		   (onSelectAll)="onSelectAllregion($event)" (onDeSelect)="onItemDeSelectregion($event)"
		   (onDeSelectAll)="onItemDeSelectAllregion($event)">
		 </ng-multiselect-dropdown> -->
		 <!-- <ng-multiselect-dropdown class="multidrop" (keydown.enter)="$event.preventDefault()" name="state"
			[placeholder]="'State '" [data]="states" 
			[settings]="dropdownStatesettings" (onSelect)="onItemSelectState($event)"
			(onSelectAll)="onSelectAllState($event)" (onDeSelect)="onItemDeSelectState($event)"
			(onDeSelectAll)="onItemDeSelectAllState()">
		</ng-multiselect-dropdown> -->
	   <!-- </div> -->
		<div class="col=lg-1">
			<button [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--info': loadingSubmit}"
			type="button" class="btn btnFill" (click)="getDashboradStatus('MTD',1)">Go</button> 
		</div>
	 </div>
   </div>
 </form>
<!-- new code start -->
 <div class="row">
	<div class="ticket-tracker-head" style="margin-left: 15px;">Asset Profile</div>
 </div>
 <br>

 <div class="row" >
	<div class="col-lg-6" >
		<!-- <div class="ticket-tracker-head">Job Tracker</div> -->
		<div class="row" >
		  <div class="col-sm-4 counter">
			<div class="card ratings" style="cursor: pointer;" (click)="pageRedirect('Asset',this.assetListData?.total_assets,1)">
			  <!-- <img class="icon" src="assets/images/cost.svg" alt="No image"> -->
			  <br>
			  <h3 class="blackfont font12px">Total Assets</h3>
			  <br>
			  <p>
				<span class="rating-score">{{this.assetListData?.total_assets}} </span>
			  </p>
			  <!-- <div style="visibility: hidden;"> Over Due</div> -->
			</div>
		  </div>
		  <div class="col-sm-4 counter">
			<div class="card ratings" style="cursor: pointer;" (click)="pageRedirect('Asset',this.assetListData?.functional,2)">
			  <!-- <img class="icon" src="assets/images/check.svg" alt="No image"> -->
			  <br>
			  <h3 class="blackfont font12px">Functional</h3>
			  <br>
			  <p>
				<span class="rating-score"> {{this.assetListData?.functional}}</span>
			  </p>
			  <!-- <div style="visibility: hidden;"> Over Due</div> -->
			</div>
		  </div>
		  <div class="col-sm-4 counter">
			<div class="card ratings" style="cursor: pointer;" (click)="pageRedirect('Asset',this.assetListData?.non_functional,3)">
			  <!-- <img class="icon" src="assets/images/work.svg" alt="No image"> -->
			  <br>
			  <h3 class="blackfont font12px">Non Functional</h3>
			  <br>
			  <p>
				<span class="rating-score">{{this.assetListData?.non_functional}}
				</span>
			  </p>
			  <!-- <div style="visibility: hidden;"> Over Due</div> -->
			</div>
		  </div>
		</div>
	  </div>
	<div class="col-lg-5">
		<div class="row"  style="background-color: white !important; margin-left: 3px;margin-right: -68px;">
			<div class="control-section col-lg-5 left_crt border-right" >
				<ejs-accumulationchart #chart2 id="chart-container3" style="height: 200px !important;background-color: white !important;" 
				[legendSettings]="{ visible: false, position: 'Right', shape: 'None' }" 
				 [enableSmartLabels]="true" (textRender)="onTextRender($event)">
					<e-accumulation-series-collection>
						<e-accumulation-series [dataSource]='assetListDataChat' xName='x' yName='y' innerRadius="50%"
							[palettes]='freshpalette' [dataLabel]="datalabel">
						</e-accumulation-series>
					</e-accumulation-series-collection>
				</ejs-accumulationchart>
			</div>
			<div class="col-lg-4" style="text-align: justify;margin-top: 60px;">
				<p style="color: black;  cursor: pointer;  font-weight: 400;" (click)="pageRedirect('Asset',this.assetListData?.total_assets,1)">Total Asset:
					{{this.assetListData?.total_assets}}
				  </p>
				  <p style="color: black;  cursor: pointer;  font-weight: 400;" (click)="pageRedirect('Asset',this.assetListData?.functional,2)"><button class="buttonTaggle"></button>Functional:
					{{this.assetListData?.functional}}
				  </p>
				  <p style="color: black;  cursor: pointer;  font-weight: 400;" (click)="pageRedirect('Asset',this.assetListData?.non_functional,3)"><button class="buttonTaggle1"></button> Non Functional:
					{{this.assetListData?.non_functional}}
				  </p>
			</div>
		</div>
	</div>
</div>
<br>
<br>
<div class="row col-lg-12">
	<div class="col-lg-6 row">
		<div class="col-lg-5 ticket-tracker-head">Complaint Profile</div>
		<div class="col-lg-3" style="margin-left: -25px;">
			<select [(ngModel)]="datePeriod1"class="form-control" (click)="changeDataPicker1(2)">
				<option value='MTD'>MTD</option>
				<option value='QTD'>QTD </option>
				<option value='YTD'>YTD</option>
				<option value='Duration'>Date Range</option>
			</select>
	  	</div>
		<div class="col-lg-4" *ngIf="!datapickerflag1">
			<button class="calenderview w-100"> <kt-date [from]="defaultFrom" [to]="defaultTo"
				(dateRangeSelection)="onDateRangeSelection($event,2,datePeriod1)"></kt-date></button>
		</div>
	</div>
	<div class="col-lg-6 row">
		<div class="col-lg-4 ticket-tracker-head" style="margin-left: 62px">PMS Profile</div>
		<div class="col-lg-3" style="margin-left: -26px;">
			<select [(ngModel)]="datePeriod"class="form-control" (click)="changeDataPicker(3)">
				<option value='MTD'>MTD</option>
				<option value='QTD'>QTD </option>
				<option value='YTD'>YTD</option>
				<option value='Duration'>Date Range</option>
			</select>
	  	</div>
		<div class="col-lg-4" *ngIf="!datapickerflag">
			<button class="calenderview w-100"> <kt-date [from]="defaultFrom" [to]="defaultTo"
				(dateRangeSelection)="onDateRangeSelection($event,3,datePeriod)"></kt-date></button>
		</div>
	</div>
 </div>
<div class="row">
	<div class="col-lg-5">
		<!-- <div></div> -->
		<div class="row flex-nowrap" style="margin-right: -88px;">
			<div class="col body_size main_body" style="cursor: pointer;" >
			  <div class="kt-space-20"></div>
			  <div class="portlet__body" (click)="pageRedirect('complaint',complaintData?.total_complaints,1)">
				<div class="ticket-text">Total complaint</div>
				<div class="ticket-count"> {{ complaintData?.total_complaints }}</div>
			  </div>
			</div>
			<div class="col body_size main_body" style="cursor: pointer;">
			 <div class="kt-space-20"></div>
			 <div class="portlet__body" (click)="pageRedirect('complaint',complaintData?.completed,2)">
			   <div class="ticket-text">Completed</div>
			   <div class="ticket-count"> {{ complaintData?.completed }}</div>
			 </div>
		   </div>
		   <div class="col body_size main_body" style="cursor: pointer;">
			 <div class="kt-space-20"></div>
			 <div class="portlet__body" (click)="pageRedirect('complaint',complaintData?.pending,3)">
			   <div class="ticket-text">Pending</div>
			   <div class="ticket-count"> {{ complaintData?.pending }}</div>
			 </div>
		   </div>
		</div>
		<br>
		<div class="row"  style="background-color: white !important; margin-left: 3px;margin-right: -76px;">
			<div class="control-section col-lg-5 left_crt border-right" >
				<ejs-accumulationchart #chart3 id="chart-container6" style="height: 200px !important;background-color: white !important;" 
				[legendSettings]="{ visible: false, position: 'Right', shape: 'None' }" 
				 [enableSmartLabels]="true" (textRender)="onTextRender($event)">
					<e-accumulation-series-collection>
						<e-accumulation-series [dataSource]='complaintDataChat' xName='x' yName='y' innerRadius="50%"
							[palettes]='freshpalette' [dataLabel]="datalabel">
						</e-accumulation-series>
					</e-accumulation-series-collection>
				</ejs-accumulationchart>
			</div>
			<div class="col-lg-4" style="text-align: justify;margin-top: 60px;">
				<p style="color: black; cursor: pointer;   font-weight: 400;" (click)="pageRedirect('complaint',complaintData?.total_complaints,1)">Total Complaint:
					{{ complaintData?.total_complaints }}
				  </p>
				  <p style="color: black; cursor: pointer;    font-weight: 400;" (click)="pageRedirect('complaint',complaintData?.completed,2)"><button class="buttonTaggle"></button>Completed:
					{{ complaintData?.completed }}
				  </p>
				  <p style="color: black; cursor: pointer;   font-weight: 400;" (click)="pageRedirect('complaint',complaintData?.pending,3)"><button class="buttonTaggle1"></button>Pending:
					{{ complaintData?.pending }}
				  </p>
			</div>
		</div>
	</div>
	<div class="col-lg-1"></div>
	<div class="col-lg-5" >
		<div class="row flex-nowrap" style="margin-right: -78px;">
			<div class="col body_size main_body" style="cursor: pointer;" >
			  <div class="kt-space-20"></div>
			  <div class="portlet__body" (click)="pageRedirect('pms',pmsData?.total_complaints,1)">
				<div class="ticket-text">Total complaint</div>
				<div class="ticket-count"> {{ pmsData?.total_complaints }}</div>
			  </div>
			</div>
			<div class="col body_size main_body" style="cursor: pointer;" >
			 <div class="kt-space-20"></div>
			 <div class="portlet__body" (click)="pageRedirect('pms',pmsData?.completed,2)">
			   <div class="ticket-text">Completed</div>
			   <div class="ticket-count"> {{ pmsData?.completed }}</div>
			 </div>
		   </div>
		   <div class="col body_size main_body" style="cursor: pointer;" >
			 <div class="kt-space-20"></div>
			 <div class="portlet__body" (click)="pageRedirect('pms',pmsData?.pending,3)">
			   <div class="ticket-text">Pending</div>
			   <div class="ticket-count"> {{ pmsData?.pending }}</div>
			 </div>
		   </div>
		</div>
		<br>
		<div class="row"  style="background-color: white !important; margin-left: 3px; margin-right: -67px;">
			<div class="control-section col-lg-5 left_crt border-right">
				<ejs-accumulationchart #chart4 id="chart-container4" style="height: 200px !important;background-color: white !important;" 
				[legendSettings]="{ visible: false, position: 'Right', shape: 'None' }" 
				 [enableSmartLabels]="true" (textRender)="onTextRender($event)">
					<e-accumulation-series-collection>
						<e-accumulation-series [dataSource]='pmsDataChat' xName='x' yName='y' innerRadius="50%"
							[palettes]='freshpalette' [dataLabel]="datalabel">
						</e-accumulation-series>
					</e-accumulation-series-collection>
				</ejs-accumulationchart>
			</div>
			<div class="col-lg-4" style="text-align: justify;margin-top: 60px;">
				<p style="color: black;  cursor: pointer;  font-weight: 400;" (click)="pageRedirect('pms',pmsData?.total_complaints,1)">Total Pms:
					{{ pmsData?.total_complaints }}
				  </p>
				  <p style="color: black; cursor: pointer;   font-weight: 400;" (click)="pageRedirect('pms',pmsData?.completed,2)"><button class="buttonTaggle"></button>Completed:
					{{ pmsData?.completed }}
				  </p>
				  <p style="color: black;  cursor: pointer;  font-weight: 400;" (click)="pageRedirect('pms',pmsData?.pending,3)"><button class="buttonTaggle1"></button>Pending:
					{{ pmsData?.pending }}
				  </p>
			</div>
		</div>
	</div>
</div>
<br>
<br>

 <!-- new code end -->